export default {
  data() {
    return {
      dialogImageUrl: "",
      imgPreviewDialogVisible: false,
      fileList: []
    }
  },
  methods: {
    uploadImg(param, callbacks = {}) {
      const { onSuccess, onError } = callbacks;
      // 上传图片到火山引擎
      this.$axios
        .post("/config/get_temp_upload_key", null, {
          headers: {
            "x-auth-token": localStorage.getItem("bde_token"),
          },
        })
        .then((res) => {
          if (res.status !== 200) {
            console.log(res)
            this.$message.error('火山引擎stsToken获取失败，请检查控制台错误信息！')
            onError && onError();
            return;
          }
          const stsToken = res.data.res.data || {};
          const fileKey = this.$ttUploader.addImageFile({
            file: param.file,
            stsToken,
          });
          // 保存回调到全局存储
          if (onSuccess || onError) {
            this.$uploadCallbacks[fileKey] = { onSuccess, onError };
          }
          // 开始上传
          this.$ttUploader.start(fileKey);
        })
        .catch((err) => {
          this.$message.error(err.response ? err.response.data.message : '上传失败');
          onError && onError(err);
        })
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.imgPreviewDialogVisible = true;
    },
  }
}
